// Seven-day streak strip — a flame on each day the daily goal was met.
import { Icon } from './icons';

const DAYS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

/** `active` is a 7-length boolean array (Mon→Sun); defaults to first `count` on. */
export function WeekStrip({ active, count }: { active?: boolean[]; count?: number }) {
  const on = active ?? DAYS.map((_, i) => i < (count ?? 0));
  return (
    <div className="flex gap-2">
      {DAYS.map((d, i) => (
        <div key={i} className="flex flex-col items-center gap-1">
          <div
            className="grid h-6 w-6 place-items-center rounded-full border"
            style={{
              borderColor: on[i] ? 'var(--orange-fill)' : 'var(--line)',
              background: on[i] ? 'var(--orange-bg)' : 'var(--paper-sunk)',
              color: '#BA5A17',
            }}
          >
            {on[i] && <Icon name="flame" size={13} />}
          </div>
          <div className="text-fs-10 text-ink-faint">{d}</div>
        </div>
      ))}
    </div>
  );
}
